<template>
  <div
    class="orbit">
    <div
      class="clip-border flex bg-red-200">
      <img 
        src="../../assets/lexa.jpg" alt="Aleksey"
        width="320"
        class="clip-mask mx-auto my-auto" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HomeGraphic'
  }
</script>

<style scoped>
  @media screen and (max-width: 480px) {
    img {
      width: 260px;
      height: 260px;
    }
    .clip-mask {
      clip-path: circle(130px);
    }
    .clip-border {
      height: 276px;
      width: 276px;
      clip-path: circle(138px);
    }
    .orbit {
      height: 286px;
      width: 276px;
    }
  }

  @media screen and (min-width: 480px) {
    .clip-mask {
      clip-path: circle(160px);
    }
    .clip-border {
      height: 334px;
      width: 334px;
      clip-path: circle(167px);
    }
    .orbit {
      height: 334px;
      width: 334px;
    }
  }
</style>
